<template>
  <div class="d-flex align-items-center">
    <toggle-button
      v-model="listing.taken_down"
      :color="{ checked: '#ff0000' }"
    >
    </toggle-button>
    <small
      class="d-inline-block ml-3"
    >
      <span v-if="listing.taken_down">
        This listing has been <b class="text-danger">taken down</b>
      </span>
      <span v-if="!listing.taken_down">
        This listing is <b class="text-success">live</b>
      </span>
    </small>
  </div>
</template>

<script>
import { takenDownListing } from '@/api'
import { ToggleButton } from 'vue-js-toggle-button'

export default {
  components: {
    ToggleButton,
  },
  props: {
    value: {
      type: Object,
      default () {
        return {}
      }
    },
  },
  data () {
    return {
      listing: this.value,
    }
  },
  watch: {
    'listing.taken_down' (value) {
      takenDownListing(this.listing.id, value)
    }
  },
}
</script>